// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__14f0S","Logo":"Header_Logo__1kQpN"};